<section class="flex flex-col overflow-y-scroll" [ngClass]="bgColorClass">
    <div
        [ngClass]="[expand() ? 'w-screen' : 'container  max-w-[1280px]', customCss()]"
        class="flex flex-col gap-3 px-4 select-none size-full lg:gap-6"
    >
        <ng-content />
    </div>
</section>
